/**
 * What every failed API call becomes, whichever transport carried it: `api()`'s fetch or
 * `uploadWithProgress`'s XHR. Its own module so the two can share it without importing each
 * other; the rest of the app imports it from `@/lib/api`, which re-exports it.
 */

export interface ProblemDetails {
    status?: number;
    title?: string;
    detail?: string;
    errors?: Record<string, string[]>;
}

export class ApiError extends Error {
    readonly status: number;
    readonly problem: ProblemDetails;

    constructor(status: number, problem: ProblemDetails) {
        super(problem.title ?? `Request failed with ${status}`);
        this.name = 'ApiError';
        this.status = status;
        this.problem = problem;
    }
}
